import { Suspense, useState } from 'react'
import { Await, defer, useLoaderData, useNavigate, Link } from 'react-router-dom'
import { tel } from '../util/api'
import LoadingSpinner from './components/LoadingSpinner'
import Heading from './helper/Heading'
import { Title } from './helper/DocumentTitle'
import styles from '../styles/module/Tel.module.scss'
import { useEffect } from 'react'

export const loader = async () => {
  return defer({ tel: tel() })
}

export default function Tel() {
  const pageName = 'تلفن های ضروری'
  Title(pageName)
  const [loaderData, setLoaderData] = useState(useLoaderData())
  const navigate = useNavigate()
  useEffect(() => {
    document.querySelector('header span').innerText = pageName
    window.scrollTo(0, 0)
  }, [])

  return (
    <section className={styles.tel}>
      <div className="__frame" data-width={`large`}>
        <Link to={`../`} className="btn btn-back-top">
          بازگشت
        </Link>
        <div className={styles.emam}>
          <figure>
            <img src={require('../../src/images/emam-khomenie.png')} />
          </figure>

          <figure>
            <img src={require('../../src/images/slogan.png')} />
          </figure>

          <figure>
            <img src={require('../../src/images/emam-khamenie.png')} />
          </figure>
        </div>
        <div className="grid grid--fit grid--gap-1" style={{ '--data-width': '300px', width: '100%' }}>
          <Suspense fallback={<LoadingSpinner />}>
            <Await resolve={loaderData.tel} errorElement={<p>⚠️</p>}>
              {(data) => {
                return (
                  <>
                    {data.map((item, i) => {
                      return (
                        <div className={styles.item} key={i}>
                          <a target={'_blank'} href={`tel://045${item.tel}`}>
                            <div className={`${styles.itemBody} d-flex align-items-center`} style={{ columnGap: '1rem' }}>
                              {item.name}
                              <span dir="ltr">045-{item.tel}</span>
                            </div>
                          </a>
                        </div>
                      )
                    })}
                  </>
                )
              }}
            </Await>
          </Suspense>
        </div>
      </div>
      <Link to={`../`} className="btn btn-back-bottom">
        بازگشت
      </Link>
    </section>
  )
}
